import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


function RegistroAdminView() {
  const [nombre, setNombre] = useState('');
  const [correo, setCorreo] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [serialKey, setSerialKey] = useState('');
  const [error, setError] = useState('');
  const [exito, setExito] = useState('');
  const navigate = useNavigate();

  const handleRegistro = async (e) => {
    e.preventDefault();
    setError('');
    setExito('');

    try {
      const response = await fetch('http://localhost:5000/api/auth/registro', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre,
          correo,
          contrasena,
          rol: 'admin',
          serial_key: serialKey
        })
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Error al registrar administrador');
        return;
      }

      setExito('Administrador registrado exitosamente');
      setTimeout(() => navigate('/admin-intro'), 2000);

    } catch (err) {
      setError('Error de conexión con el servidor');
    }
  };

  return (

    
   
    <div style={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh', fontFamily: 'Arial, sans-serif' }}>
    
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px' }}>
        <div style={{
          backgroundColor: '#111',
          padding: '40px',
          borderRadius: '8px',
          boxShadow: '0 0 10px rgba(255, 0, 0, 0.5)',
          width: '100%',
          maxWidth: '400px'
        }}>
          <h2 style={{ color: '#ff0000', textAlign: 'center', marginBottom: '30px' }}>Registro de administrador</h2>
          <form onSubmit={handleRegistro}>
            <input
              type="text"
              placeholder="Nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
              style={inputStyle}
            />
            <input
              type="email"
              placeholder="Correo"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
              style={inputStyle}
            />
            <input
              type="password"
              placeholder="Contraseña"
              value={contrasena}
              onChange={(e) => setContrasena(e.target.value)}
              required
              style={inputStyle}
            />
            <input
              type="text"
              placeholder="Serial de administrador"
              value={serialKey}
              onChange={(e) => setSerialKey(e.target.value)}
              required
              style={inputStyle}
            />
            <button type="submit" style={buttonStyle}>Registrar</button>
          </form>
          {error && <p style={{ color: '#ff4d4d', marginTop: '15px', textAlign: 'center' }}>{error}</p>}
          {exito && <p style={{ color: '#00ff99', marginTop: '15px', textAlign: 'center' }}>{exito}</p>}
        </div>
      </div>
    </div>
    
   
  );
}

const inputStyle = {
  width: '100%',
  padding: '12px',
  marginBottom: '15px',
  borderRadius: '4px',
  border: '1px solid #444',
  backgroundColor: '#222',
  color: '#fff',
  fontSize: '14px'
};

const buttonStyle = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#ff0000',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  fontSize: '16px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease'
};

export default RegistroAdminView;
